export enum FMActionTypes {
  VIEW = 'view_action',
  DOWNLOAD = 'download_action',
  ACTIVITIES = 'show_activities',
  CHANGE = 'change_action',
  DELETE = 'delete_action',
  SHARE = 'share_action',
  UPLOAD = 'upload_action',
  UNSHARED = 'unshared_action',
}

export enum FileCategories {
  documents = 'document',
  images = 'image',
  video = 'video',
  audio = 'audio',
}

export enum ActivityLog {
  activities = 'activities',
}
export enum FileOwnershipTypes {
  manager = 'manager',
  shared = 'shared',
  public = 'public',
}

export enum TypeOfAction {
  DOWNLOAD = 'DOWNLOAD',
  DELETE = 'DELETE',
  SHARE = 'SHARE',
  UNSHARED = 'UNSHARE',
}
